<template>
  <div>
    <CButtonGroup class="mt-2 typeTable">
      <CButton
        color="outline-transparent"
        v-for="(value, index) in ['email', 'sms']"
        :key="index"
        class="mx-0 text-uppercase"
        :pressed="isTabSelected(value)"
        @click="selectTab(value)"
      >
        <CIcon :name="value" size="custom-size" :height="25" viewBox="0 0 32 32" />
        <span class="ml-2">
          {{ value }}
        </span>
      </CButton>
    </CButtonGroup>
    <slot>tabArea</slot>
  </div>
</template>

<script>
export default {
  props: {
    tabs: Array,
    targetTab: {
      type: String,
      required: false,
    },
  },
  mounted() {
    this.selectTab(this.targetTab ?? this.tabs[0])
  },
  data() {
    return {
      selected: null,
    }
  },
  methods: {
    selectTab(tab) {
      this.selected = tab ?? null

      if (this.$route.query.tab === this.selected) return

      this.$router.replace({ path: this.$route.fullPath, query: { tab: this.selected } })
    },
    isTabSelected(tab) {
      return this.selected === tab
    },
  },
}
</script>

<style lang="scss">
.tab-bar {
  border-bottom: 1px solid $gray-500;
}
.tab-item {
  display: inline-block;
  margin-bottom: -1px;
  padding-bottom: 8px;
  opacity: 0.8;
  color: $gray-600 !important;
  border-bottom: 1px solid $gray-500;
  font-size: 17px !important;
  font-weight: 600;
  &:hover {
    border-bottom: 1px solid $gray-600;
    opacity: 1;
  }
}

.tab-item-active {
  color: $gray-base !important;
  border-bottom: 1px solid $gray-base !important;
  opacity: 1;
}
</style>
